import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingFlow,
  UpdateMarketingFlowStatusPayload
} from "../../marketing.types";

export const requestUpdateMarketingFlowStatus = async ({
  flowId,
  status
}: UpdateMarketingFlowStatusPayload): Promise<MarketingFlow> => {
  return await instance.patch(`${ApiRoutesMarketing.Flows}/${flowId}/status`, {
    status
  });
};
